module.exports = __webpack_public_path__ + "img/ic-smartplug-active.d4b3caf7.svg";